module.exports = __webpack_public_path__ + "files/9e41e350b4f4e2d2d0f09d7e283d063b.png";